import {
   Box,
   Button,
   FormControl,
   Grid,
   InputLabel,
   MenuItem,
   Select,
   TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import { views } from "./defineUtils";
import { useDispatch, useSelector } from "react-redux";
import { GetQuotaChartData, setState } from "./defineSlice";

export default function ViewSearchRefresh() {
   const dispatch = useDispatch();
   const define = useSelector((store) => store.define);
   const { searchText, selectedView, gridData,filter_customerTypes, filter_customerTrustLevels, filter_skuName, selectedProduct} = define;

   function setView(event) {
      const value = event.target.value;
      dispatch(setState("selectedView", value));
   }

   function setSearchText(event) {
      let text = event.target.value;
      dispatch(setState("searchText", text));  
      handleSearch(text);
   }

   function handleSearch(str) {
      if(str.length === 0) {
         let val = gridData?.filter((item) =>{
            return(
            (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
            (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
            (filter_skuName.length === 0 || filter_skuName.some(sku => item.skuName.toLowerCase().includes(sku.toLowerCase()))) &&
            (selectedProduct.packGroupOrSKUID === 0 || selectedProduct.packGroupOrSKUID === undefined || item.skuid === selectedProduct.packGroupOrSKUID)
            );});
         dispatch(setState("gridDataFiltered", val));
         return;
      }
      let text = str.toLowerCase();
      // let searchedItems = [];
      // gridData.forEach((item) => {
      //    const flag =
      //       item.skuName?.toLowerCase().includes(text) ||
      //       item.skuNumb?.toLowerCase().includes(text) ||
      //       item.customerName?.toLowerCase().includes(text) ||
      //       item.customerGroupName?.toLowerCase().includes(text) ||
      //       item.customerNumber?.toLowerCase().includes(text);
      //    if (flag) {
      //       searchedItems.push(item);
      //    }
      // });
      // console.log("Define_ViewSearchRefresh_handleSearch", text, searchedItems);
      // dispatch(setState("gridDataFiltered", []));
      // dispatch(setState("gridDataFiltered", searchedItems));

      let val = gridData?.filter((item) =>{
         return(
         (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
         (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
         (filter_skuName.length === 0 || filter_skuName.some(sku => item.skuName.toLowerCase().includes(sku.toLowerCase()))) &&
         (selectedProduct.packGroupOrSKUID === 0 || selectedProduct.packGroupOrSKUID === undefined || item.skuid === selectedProduct.packGroupOrSKUID) &&
         (item.skuName?.toLowerCase().includes(text) ||
         item.skuNumb?.toLowerCase().includes(text) ||
         item.customerName?.toLowerCase().includes(text) ||
         item.customerGroupName?.toLowerCase().includes(text) ||
         item.customerNumber?.toLowerCase().includes(text))
         );});
       dispatch(setState("gridDataFiltered", val));
   }

   function refresh() {
      dispatch(GetQuotaChartData({ method: "POST" }));
   }

   return (
      <Box sx={{ mt: 2, mb: 3 }}>
         <Grid container columns={12} spacing={2}>
            <Grid item xs={12} md={2.5}>
               <FormControl variant={"outlined"}>
                  <Select value={selectedView} onChange={setView}>
                     {views.map((item, index) => {
                        return (
                           <MenuItem key={index} value={item.key}>
                              {item.value}
                           </MenuItem>
                        );
                     })}
                  </Select>
               </FormControl>
            </Grid>

            <Grid item xs={12} md={3.5}>
               <TextField
                  variant="outlined"
                  placeholder="search"
                  value={searchText}
                  onChange={setSearchText}
               />
            </Grid>

            <Grid item xs={12} md={1}>
               <Button sx={{
					bgcolor: "darkred.light",
					color: "white.main",
					fontWeight: "700",
               height : "42px",
					textTransform: "none",
					"&:hover": {
						bgcolor: "darkred.main",

					},
				   }}
               variant="contained" onClick={refresh}>Refresh</Button>
            </Grid>
         </Grid>
      </Box>
   );
}
